import React, { useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Formik } from 'formik'
import { accessCodesSchema } from 'lib/schemas'
import AccessCodes from './AccessCodes'
import { createAccessCodes } from 'store/sitesManager/operations'
import { selectCreateAccessCodesData } from 'store/sitesManager/selector'
import { RootState } from 'types'

const parseSiteIds = (siteIdsString: string): number[] => {
  return siteIdsString
    .split(',')
    .map(id => id.trim())
    .filter(id => id.length > 0)
    .map(id => parseInt(id, 10))
    .filter(id => !isNaN(id))
}

const AccessCodesContainer: React.FC = () => {
  const dispatch = useDispatch()
  const { createdItems, failedItems, isLoading } = useSelector(
    (state: RootState) => selectCreateAccessCodesData(state.sitesManager),
  )

  const handleSubmit = useCallback(
    async (
      values: { siteIds: string },
      { setSubmitting }: { setSubmitting: (isSubmitting: boolean) => void },
    ) => {
      const siteIds = parseSiteIds(values.siteIds)
      try {
        await dispatch(createAccessCodes(siteIds) as any)
      } finally {
        setSubmitting(false)
      }
    },
    [dispatch],
  )

  return (
    <Formik
      initialValues={{
        siteIds: '',
      }}
      validationSchema={accessCodesSchema}
      onSubmit={handleSubmit}
      validateOnChange
      validateOnBlur
    >
      {formikProps => (
        <AccessCodes
          {...formikProps}
          createdItems={createdItems}
          failedItems={failedItems}
          isLoading={isLoading}
        />
      )}
    </Formik>
  )
}

export default AccessCodesContainer
